module.exports = __webpack_public_path__ + "media/img/clients/client5-0ee866c910031bf196d85b2d23d859d4.svg";